import {Component, Input, OnInit} from '@angular/core';
import {ProjectConstants} from '../../project-constants';
import {FilterAbstractModel} from '../../../models/FilterAbstractModel';

@Component({
  selector: 'app-workflow-status-filter',
  templateUrl: './workflow-status-filter.component.html',
  styleUrls: ['./workflow-status-filter.component.scss']
})
export class WorkflowStatusFilterComponent extends FilterAbstractModel implements OnInit {
  workflowStatusList: string[];
  optionSelected: any;

  @Input() filterSelected?: string;

  constructor() {
    super();
  }

  ngOnInit() {
    this.workflowStatusList = new ProjectConstants().WORKFLOW_STATUS_LIST;
    if (this.filterSelected && this.filterSelected !== '') {
      this.optionSelected = this.filterSelected;
    }
  }

  getElementSelected() {
    //TODO
  }

  compareObjects(o1: any, o2: any) {
    if (o2 === undefined || o2 === null) {
      return false;
    }
    return o1 === o2;
  }

  reset() {
    this.optionSelected = null;
  }
}
